import logo from '../assets/logo.svg';

/** Logo z design/_logo200.part — jediný zdroj pravdy je ten SVG súbor. */
export function Logo({ size = 'sm' }: { size?: 'sm' | 'lg' }) {
  const width = size === 'lg' ? 200 : 140;
  return <img src={logo} width={width} height={Math.round(width * 0.1795)} alt="Ametica" className="block" />;
}
